import * as R from 'ramda'

import type { ScormSettings } from 'services/Store/Project/types'

export const getScormSettings = R.path<ScormSettings>(['data', 'scormSettings'])
